import { foot, type WorldObject } from './mapdef';

/** Interactive objects of the sky package (ids prefixed, see mapdef ObjectId). */
export const OBJECTS_SKY: readonly WorldObject[] = [
  // A tear-off calendar (撕日曆) on the kitchen wall: today's date, weather and tomorrow's forecast.
  { id: 'sky_calendar', map: 'home', rect: foot(15, 1, 1, 6), solid: false, label: 'sky_calendar', icon: '📅', tall: 26 },
  // The family's emergency kit by the front door: the typhoon checklist.
  { id: 'sky_kit', map: 'home', rect: foot(5, 15, 1, 8), solid: true, label: 'sky_kit', icon: '🎒', tall: 14 },
  // The bucket of umbrellas by every convenience-store door.
  { id: 'sky_umbrellas', map: 'store', rect: foot(5, 8, 1, 6), solid: true, label: 'sky_umbrellas', icon: '☂️', tall: 18 },
];
